import React, { Component } from 'react';
import Modal from 'react-modal';
import Button from 'admin/components/shared/Button';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { closeAlertModal } from 'admin/actions/alert-modal';

const modalDefaultStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    textAlign: 'center',
  },
  overlay: {
    zIndex: 1001, // make sure fronter than LoadingSpinner
  },
};

class AlertModal extends Component {

  constructor(props) {
    super(props);
  }

  render() {
    const cancelAlertModal = () => {
      this.props.closeAlertModal();
      this.props.onCancel();
    };
    const confirmAlertModal = () => {
      this.props.closeAlertModal();
      this.props.onConfirm();
    };
    const style = {
      content: Object.assign({}, modalDefaultStyles.content, this.props.styles.content),
      overlay: Object.assign({}, modalDefaultStyles.overlay, this.props.styles.overlay),
    };
    return (
      <Modal isOpen={this.props.isModalOpen}
             onRequestClose={cancelAlertModal}
             shouldCloseOnOverlayClick={this.props.shouldCloseOnOverlayClick}
             closeTimeoutMS={200}
             ariaHideApp={false}
             style={style} >
        <div>{this.props.body}</div>
        {
          (this.props.useConfirm || this.props.useCancel) ? (
            <div style={{marginTop:"20px"}}>
              {
                this.props.useCancel ?
                <Button onClick={cancelAlertModal} color={this.props.cancelColor} style={{marginRight:"10px"}}>{this.props.cancelText}</Button> :
                null
              }
              {
                this.props.useConfirm ?
                <Button onClick={confirmAlertModal} color={this.props.confirmColor}>{this.props.confirmText}</Button> :
                null
              }
            </div>
          ) : null
        }
      </Modal>
    );
  }

}

const nothingToDo = () => {};

AlertModal.defaultProps = {
  isModalOpen: false,
  body: null,
  useCancel: true,
  useConfirm: true,
  shouldCloseOnOverlayClick: true,
  styles: {
    content: {},
    overlay: {},
  },
  confirmText: "OK",
  cancelText: "キャンセル",
  confirmColor: "normal",
  cancelColor: "gray",
  onCancel: nothingToDo,
  onConfirm: nothingToDo,
  closeAlertModal: nothingToDo,
};

const mapStateToProps = state => ({});
const mapDispatchToProps = dispatch => bindActionCreators({ closeAlertModal }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(AlertModal);
